<div class="wrapper" *ngIf="train">
  <div class="m-2" style="white-space: nowrap" *ngIf="details">
    <div style="display: inline-block">
      <button class="btn btn-primary" (click)="exportToExcel()"><i class="fal fa-file-excel fa-lg"></i></button>
    </div>
    <div class="card" style="display: inline-block; width: 470px; margin-left: 10px;">
      <div class="card-header">
        {{'Part-travel information' | translate}}
      </div>
      <table *ngIf="legs && legs.length > 0; else trainManifestElseBlock" class="table table-sm">
        <thead>
        <tr>
          <th style="width: 120px">{{'Route' | translate}}</th>
          <th style="width: 120px">{{'JKV-speed' | translate}}</th>
          <th style="width: 70px">{{'Break type' | translate}}</th>
          <th style="width: 160px">{{'Break weight percentage' | translate}}</th>
        </tr>
        </thead>
        <tbody style="overflow-y: visible">
        <ng-container *ngFor="let row of legs">
          <tr *ngFor="let leg of row.JP">
            <td style="width: 120px">{{leg.ATU_MISTA}} - {{leg.ATU_MIHIN}}</td>
            <td style="width: 120px">{{leg.ATU_JKV_NOPEUS}}</td>
            <td style="width: 70px">{{leg.ATU_JARRULAJI}}</td>
            <td style="width: 160px">{{getJPP(leg.ATU_JP_PROSENTTI)}}</td>
          </tr>
        </ng-container>
        </tbody>
      </table>
      <ng-template #trainManifestElseBlock>
        {{'Cargo manifest is not available for this train.' | translate}}
      </ng-template>
    </div>
    <div class="card" style="display: inline-block; width: 220px; margin-left: 10px;">
      <div class="card-header">
        {{'Locomotives' | translate}}
      </div>
      <ul class="list-group list-group-flush">
        <li class="list-group-item">
          <p>
            {{'Locomotive type' | translate}}
          </p>
          <p class="text-block">
            {{details.JLP_LITTERA}}
          </p>
        </li>
        <li class="list-group-item">
          <p>
            {{'Locomotive count' | translate}}
          </p>
          <p class="text-block">
            {{details.JLP_LKM}}
          </p>
        </li>
        <li class="list-group-item">
          <p>
            {{'Length of locomotives' | translate}}
          </p>
          <p class="text-block">
            {{details.JLP_VETURIEN_PITUUS}}
          </p>
        </li>
      </ul>
    </div>
    <div class="card" style="display: inline-block; width: 240px; margin-left: 10px;">
      <div class="card-header">
        {{'Wagons' | translate}}
      </div>
      <ul class="list-group list-group-flush">
        <li class="list-group-item">
          <p>
            {{'Wagon weight' | translate}}
          </p>
          <p class="text-block">
            {{details.maxWeight}}
          </p>
        </li>
        <li class="list-group-item">
          <p>
            {{'Wagon length' | translate}}
          </p>
          <p class="text-block">
            {{details.maxLength}}
          </p>
        </li>
        <li class="list-group-item">
          <p>
            {{'Wagon count' | translate}}
          </p>
          <p class="text-block">
            {{details.wagonCount}}
          </p>
        </li>
        <li class="list-group-item">
          <p>
            {{'Wagon axle count' | translate}}
          </p>
          <p class="text-block">
            {{details.wagonAxleCount}}
          </p>
        </li>
      </ul>
    </div>
    <div class="card" style="display: inline-block; width: 220px; margin-left: 10px;">
      <div class="card-header">
        {{'Train' | translate}}
      </div>
      <ul class="list-group list-group-flush">
        <li class="list-group-item">
          <p>
            {{'Train length' | translate}}
          </p>
          <p class="text-block">
            {{details.trainLength}}
          </p>
        </li>
        <li class="list-group-item">
          <p>
            {{'Max train speed' | translate}}
          </p>
          <p class="text-block">
            {{details.JLP_SUURINJUNANOPEUS}}
          </p>
        </li>
        <li class="list-group-item">
          <p>
            {{'Train axle count' | translate}}
          </p>
          <p class="text-block">
            {{details.trainAxleCount}}
          </p>
        </li>
      </ul>
    </div>
    <!--
    Veturityyppi: {{details.JLP_LITTERA}}
    Veturien lukumäärä: {{details.JLP_LKM}}
    Suurin junanopeus: {{details.JLP_SUURINJUNANOPEUS}}
    Junan kokonaispaino: {{details.maxWeight}}
    Vaunuston pituus: {{details.maxLength}}
    Veturien pituus: {{details.JLP_VETURIEN_PITUUS}}
    -->
  </div>
  <div #cargoManifest id="cargo-manifest-table" role="table" *qmLoading="loading;config:loadingConfig">
    <ng-container *ngFor="let wagonHeader of wagonTableHeaders">
      <div class="grid-header" role="columnheader">{{wagonHeader}}</div>
    </ng-container>
    <ng-container *ngFor="let wagonTableRow of wagonTable; let i = index">
      <div class="grid-cell" role="cell">
        {{ wagonTableRow.index }}
      </div>
      <div class="grid-cell" role="cell">
        {{ wagonTableRow.littera }}
      </div>
      <div class="grid-cell" role="cell">
        <a (click)="openHover(wagonTableRow.wagon, 'WAGON', $event)" class="link">
          {{ wagonTableRow.numero }}
        </a>
      </div>
      <div class="grid-cell" role="cell">
        {{ wagonTableRow.maakoodi }}
      </div>
      <div class="grid-cell" role="cell">
        <ng-container *ngFor="let ktiLahtoRow of wagonTableRow.ktiLahto">
          {{ktiLahtoRow}}
          <br/>
        </ng-container>
      </div>
      <div class="grid-cell" role="cell">
        <ng-container *ngFor="let ktiMaaraRow of wagonTableRow.ktiMaara">
          {{ktiMaaraRow}}
          <br/>
        </ng-container>
      </div>
      <div class="grid-cell" role="cell">
        {{wagonTableRow.weight}}
      </div>
      <div class="grid-cell" role="cell">
        <ng-container *ngFor="let cargoInfo of wagonTableRow.ktrTavaraNimi">
          {{cargoInfo}}
          <br/>
        </ng-container>
      </div>
      <div class="grid-cell" role="cell">
        <ng-container *ngFor="let cargoInfo of wagonTableRow.ktrRahtikirjaNro">
          {{cargoInfo}}
          <br/>
        </ng-container>
      </div>
      <div class="grid-cell" role="cell">
        <ng-container *ngFor="let shipment of wagonTableRow.shipments">
          <a (click)="openHover(shipment, 'SENDER', $event)" class="link">
            {{shipment.KTI_LAHETTAJA_NIMI}}
          </a>
          <br/>
        </ng-container>
      </div>
      <div class="grid-cell" role="cell">
        <ng-container *ngFor="let shipment of wagonTableRow.shipments">
          <a (click)="openHover(shipment, 'RECIPIENT', $event)" class="link">
            {{shipment.KTI_VASTOTTAJA_NIMI}}
          </a>
          <br/>
        </ng-container>
      </div>
      <div class="grid-cell" role="cell">
        <ng-container *ngFor="let cargoInfo of wagonTableRow.ktrVaaraTunnus">
          <a href="https://www.ttl.fi/ova/kaytop.html#ots154" rel="noopener noreferrer" target="_blank">{{cargoInfo}}</a>
          <br/>
        </ng-container>
      </div>
      <div class="grid-cell" role="cell">
        <ng-container *ngFor="let cargoInfo of wagonTableRow.ktrYkTunnus">
          <a href="{{getVAKLink(cargoInfo)}}" target="_blank">{{cargoInfo}}</a>
          <br/>
        </ng-container>
      </div>
      <div class="grid-cell" role="cell">
        <ng-container *ngFor="let cargoInfo of wagonTableRow.ktrLipuke">
          {{cargoInfo}}
          <br/>
        </ng-container>
      </div>
      <div class="grid-cell" role="cell" [innerHTML]="wagonTableRow.vakRowText"></div>
      <div class="grid-cell" role="cell">
        <ng-container *ngFor="let cargoInfo of wagonTableRow.ktrViimPurkAikaDate">
          {{cargoInfo}}
          <br/>
        </ng-container>
      </div>
    </ng-container>
  </div>

  <qm-overlay-panel #detailsOverlay [stickTo]="'right-bottom'" [appendTo]="'body'">
    <div class="card hover-container" *ngIf="selectedShipmentRow || selectedWagonRow">
      <div class="card-header">
        <ng-container [ngSwitch]="hoverType">
          <span *ngSwitchCase="'SENDER'">{{'Sender details' | translate}}</span>
          <span *ngSwitchCase="'RECIPIENT'">{{'Recipient details' | translate}}</span>
          <span *ngSwitchCase="'WAGON'">{{'Wagon details' | translate}}</span>
          <span *ngSwitchCase="'SHIP'">{{'Ship details' | translate}}</span>
        </ng-container>
        <a [attr.data-btnId]="getElementId('hide')" class="float-right" (click)="hide()">
          <svg class="svg-inline--fa fa-w-20">
            <use xlink:href="#window-close"></use>
          </svg>
        </a>
      </div>
      <div class="card-body">
        <ng-container [ngSwitch]="hoverType">
          <ng-container *ngSwitchCase="'SENDER'">
            <ng-content *ngTemplateOutlet="senderDetails"></ng-content>
          </ng-container>
          <ng-container *ngSwitchCase="'RECIPIENT'">
            <ng-content *ngTemplateOutlet="recipientDetails"></ng-content>
          </ng-container>
          <ng-container *ngSwitchCase="'WAGON'">
            <ng-content *ngTemplateOutlet="wagonDetails"></ng-content>
          </ng-container>
          <ng-container *ngSwitchCase="'SHIP'">
            <ng-content *ngTemplateOutlet="shipDetails"></ng-content>
          </ng-container>
        </ng-container>
      </div>
    </div>
  </qm-overlay-panel>

  <ng-template #recipientDetails>
    <div class="d-flex flex-column">
      <div>{{'Recipient' | translate}}</div>
      <div>{{'City' | translate}}</div>
      <div>{{'Postal code' | translate}}</div>
    </div>
    <div class="d-flex flex-column ml-2 details-column">
      <div>{{selectedShipmentRow.KTI_VASTOTTAJA_NIMI}}</div>
      <div>{{selectedShipmentRow.KTI_VASTOTTAJA_POSTITP}}</div>
      <div>{{selectedShipmentRow.KTI_VASTOTTAJA_POSTINRO}}</div>
    </div>
  </ng-template>

  <ng-template #senderDetails>
    <div class="d-flex flex-column">
      <div>{{'Sender' | translate}}</div>
      <div>{{'City' | translate}}</div>
      <div>{{'Postal code' | translate}}</div>
      <div>{{'Address' | translate}}</div>
      <div>{{'Identifier' | translate}}</div>
    </div>
    <div class="d-flex flex-column ml-2 details-column">
      <div>{{selectedShipmentRow.KTI_LAHETTAJA_NIMI}}</div>
      <div>{{selectedShipmentRow.KTI_LAHETTAJA_POSTITP}}</div>
      <div>{{selectedShipmentRow.KTI_LAHETTAJA_POSTINRO}}</div>
      <div>{{selectedShipmentRow.KTI_LAHETTAJA_OSOITE}}</div>
      <div>{{selectedShipmentRow.KTI_LAHETTAJA_TUNNUS}}</div>
    </div>
  </ng-template>

  <ng-template #shipDetails>
    <ng-container *ngFor="let cargoInfo of getCargoInfoForRow(selectedWagonRow.I)">
      <div class="d-flex flex-column">
        <div>{{'Terminal' | translate}}</div>
        <div>{{'Ship' | translate}}</div>
        <div>{{'Ship departure date' | translate}}</div>
        <div>{{'Final time of unloading' | translate}}</div>
      </div>
      <div class="d-flex flex-column ml-2 details-column">
        <div>{{cargoInfo.KTR_TERMINAALI}}</div>
        <div>{{cargoInfo.KTR_LAIVA}}</div>
        <div>{{cargoInfo.KTR_LAIVAN_LAHTOPVM}}</div>
        <div>{{cargoInfo.KTR_VIIM_PURK_AIKA}}</div>
      </div>
      <br/>
    </ng-container>
  </ng-template>

  <ng-template #wagonDetails>
    <div class="d-flex flex-column">
      <div>{{'number of axles' | translate}}</div>
      <div>{{'Equipment number' | translate}}</div>
      <div>{{'Carrying capacity' | translate}}</div>
      <div>{{'Ticket' | translate}}</div>
      <div>{{'Length' | translate}}</div>
      <div>{{'Descent limit' | translate}}</div>
      <div>{{'Rail break limit' | translate}}</div>
      <div>{{'Tare' | translate}}</div>
      <div>{{'Volume' | translate}}</div>
      <div>{{'Country' | translate}}</div>
      <div>{{'Does break work' | translate}}</div>
      <div>{{'Overall weight' | translate}}</div>
      <div>{{'Transfer train date' | translate}}</div>
      <div>{{'Transfer train carriage group' | translate}}</div>
      <div>{{'Transfer train number' | translate}}</div>
      <div>{{'Transportation quality' | translate}}</div>
      <div>{{'Departure station' | translate}}</div>
      <div>OSK_YLIMHUOM</div>
      <div>{{'Break weight' | translate}}</div>
    </div>
    <div class="d-flex flex-column ml-2 details-column">
      <div>{{selectedWagonRow.KAL_AKSELILUKU}}</div>
      <div>{{selectedWagonRow.KAL_KALNRO}}</div>
      <div>{{selectedWagonRow.KAL_KANTAVUUS}}</div>
      <div>{{selectedWagonRow.KAL_LITTERA}}</div>
      <div>{{selectedWagonRow.KAL_PITUUS}}</div>
      <div>{{selectedWagonRow.KAL_RAJ_LASKUMAESSA === '1' ? ('Yes' | translate) : ('No' | translate)}}</div>
      <div>{{selectedWagonRow.KAL_RAJ_RAIDEJARRUSSA === '1' ? ('Yes' | translate) : ('No' | translate)}}</div>
      <div>{{selectedWagonRow.KAL_TAARA}}</div>
      <div>{{selectedWagonRow.KAL_TILAVUUS}}</div>
      <div>{{selectedWagonRow.MAA_MAAKOODI}}</div>
      <div>{{selectedWagonRow.E.KAL_TOIMIIKO_JARRU === '1' ? ('Yes' | translate) : ('No' | translate)}}</div>
      <div>{{selectedWagonRow.E.OSK_BRUTTO}}</div>
      <div>{{selectedWagonRow.E.OSK_JATKOJUNA_PVM}}</div>
      <div>{{selectedWagonRow.E.OSK_JATKOJUNA_VAUNURYHMA}}</div>
      <div>{{selectedWagonRow.E.OSK_JATKOJUNANUMERO}}</div>
      <div>{{selectedWagonRow.E.OSK_KULJETUSLAATU}}</div>
      <div>{{selectedWagonRow.E.OSK_LAHTOASEMA}}</div>
      <div>{{selectedWagonRow.E.OSK_YLIMHUOM}}</div>
      <div>{{selectedWagonRow.E.VLV_JARRU_PAINO}}</div>
    </div>
  </ng-template>
